import { Hero } from "../components/site/Hero";
import { EmergencyBanner } from "../components/site/EmergencyBanner";
import { Services } from "../components/site/Services";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { ServiceAreas } from "../components/site/ServiceAreas";
import { Gallery } from "../components/site/Gallery";
import { Testimonials } from "../components/site/Testimonials";
import { FAQ } from "../components/site/FAQ";
import { ContactForm } from "../components/site/ContactForm";

export default function Home() {
  return (
    <>
      <Hero />
      <EmergencyBanner />
      <Services />
      <WhyChooseUs />
      <ServiceAreas />
      <Gallery />
      <Testimonials />
      <FAQ />
      <ContactForm />
    </>
  );
}
